/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Stored preferred export format for Slovenian accounting handoff.
 * @nullable
 */
export type UpdateSloveniaTaxProfileBodyAccountingExportsPreferredFormat = typeof UpdateSloveniaTaxProfileBodyAccountingExportsPreferredFormat[keyof typeof UpdateSloveniaTaxProfileBodyAccountingExportsPreferredFormat] | null;


export const UpdateSloveniaTaxProfileBodyAccountingExportsPreferredFormat = {
  vod_xml: 'vod_xml',
  vasco_xml: 'vasco_xml',
  minimax_xml: 'minimax_xml',
} as const;
